export default "__VITE_ASSET__Bd5osZrR__"